// Role labels
export const ROLE_LABELS = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  STAFF: 'Staff',
  SECURITY_OUT: 'Security (Gate Out)',
  SECURITY_IN: 'Security (Gate In)',
  DRIVER: 'Driver / Carrier',
  MERCHANT_EXPORTER: 'Merchant Exporter',
};

// Gate Pass type labels
export const GP_TYPE_LABELS = {
  OUT_RM:  'Outward — Raw Material',
  OUT_FP:  'Outward — Finished Product',
  IN_RM:   'Inward — Raw Material',
  IN_FP:   'Inward — Finished Product',
  RET:     'Returnable',
  ITR:     'Internal Transfer',
  OUT_ICE: 'Outward — Ice',
  IN_ICE:  'Inward — Ice',
  OUT_FC:  'Outward — Factory Consumables',
  IN_FC:   'Inward — Factory Consumables',
  OUT_GEN: 'Outward — General Items',
  IN_GEN:  'Inward — General Items',
};

// Sub-type labels
export const GP_SUBTYPE_LABELS = {
  TO_OWN_FACTORY:       'To Own Factory',
  TO_THIRD_PARTY_PPC:   'To Third-Party PPC',
  EXPORT_SHIPMENT:      'Export Shipment',
  FACTORY_TO_FACTORY:   'Factory-to-Factory Transfer',
  TO_MERCHANT_EXPORTER: 'To Merchant Exporter',
  FROM_SUPPLIER:        'From Supplier',
  FROM_OWN_FACTORY:     'From Own Factory',
  FROM_THIRD_PARTY_PPC: 'From Third-Party PPC',
  FOR_REPAIR:           'For Repair',
  INTER_FACTORY_LOAN:   'Inter-Factory Loan',
};

// Status labels & badge classes
export const STATUS_CONFIG = {
  DRAFT:                    { label: 'Draft',           badge: 'badge-draft' },
  SUBMITTED:                { label: 'Submitted',       badge: 'badge-submitted' },
  CHECKED:                  { label: 'Checked',         badge: 'badge-checked' },
  APPROVED:                 { label: 'Approved',        badge: 'badge-approved' },
  DISPATCHED:               { label: 'Dispatched',      badge: 'badge-dispatched' },
  RECEIVED:                 { label: 'Received',        badge: 'badge-received' },
  DELIVERED:                { label: 'Delivered',       badge: 'badge-delivered' },
  RETURNED:                 { label: 'Returned',        badge: 'badge-returned' },
  REJECTED:                 { label: 'Rejected',        badge: 'badge-rejected' },
  CANCELLED:                { label: 'Cancelled',       badge: 'badge-cancelled' },
  ARRIVING:                 { label: 'Arriving',        badge: 'badge-pending' },
  SECURITY_IN_ACKNOWLEDGED: { label: 'Security In Ack', badge: 'badge-checked' },
  QC_CHECKED:               { label: 'QC Checked',      badge: 'badge-checked' },
  ACCEPTED:                 { label: 'Accepted',        badge: 'badge-accepted' },
  CREATED:                  { label: 'Created',         badge: 'badge-created' },
  SECURITY_OUT_ACKNOWLEDGED:{ label: 'Security Out',    badge: 'badge-dispatched' },
  IN_TRANSIT:               { label: 'In Transit',      badge: 'badge-in_transit' },
  PENDING_ACKNOWLEDGMENT:   { label: 'Pending Ack.',    badge: 'badge-pending' },
  COMPLETED:                { label: 'Completed',       badge: 'badge-approved' },
};

// IST timezone helper
export const IST = 'Asia/Kolkata';

export const ACCEPTED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/heic', 'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

// Freezing types for Finished Products
export const FREEZING_TYPES = [
  { value: 'BLOCK',      label: 'Block Frozen' },
  { value: 'IQF',        label: 'IQF' },
  { value: 'SEMI_IQF',   label: 'Semi-IQF' },
  { value: 'BLAST',      label: 'Blast Frozen' },
];

// Ice quantity units
export const ICE_QTY_UNITS = ['BOX', 'CAN', 'KG'];

// Ice usage types
export const ICE_USAGE_TYPES = [
  { value: 'OWN_CONSUMPTION', label: 'Own Consumption' },
  { value: 'SALES',           label: 'Sales' },
];

// Form options for RM
export const FORMS = ['HOSO', 'HLSO', 'PD', 'PND', 'PDTO', 'IQF Whole', 'IQF Fillet', 'Other'];

// Gate pass types that allow "By Hand" carrier
export const BY_HAND_ALLOWED_TYPES = ['RET', 'OUT_GEN', 'IN_GEN', 'OUT_FC', 'IN_FC'];
